import { useState } from 'react';

interface Params {
    onError?: (error: Error) => void;
}

/**
 * Use this hook in case you want to know when promise call have starded and when it will end.
 *
 * @example
 * const [submitting, handleSubmit] = usePromiseState()
 * ...
 * <Button
 *     loading={submitting}
 *     onClick={handleSubmit(() => dispatch(....))}
 * >
 *     Click Me !
 * </Button>
 */
export const usePromiseState = ({ onError }: Params = {}) => {
    const [counter, setCounter] = useState(0);

    const handleCalling =
        <R, Args extends unknown[]>(fn: (...args: Args) => Promise<R>) =>
        async (...args: Args) => {
            let res: R | null = null;

            try {
                setCounter((c) => c + 1);
                res = await fn(...args);
            } catch (error) {
                if (onError) {
                    onError(error);
                } else {
                    throw error;
                }
            } finally {
                setCounter((c) => c - 1);
            }

            return res;
        };

    return [counter !== 0, handleCalling] as const;
};
